// src/hooks/productTypes/useRestoreProductType.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreProductType as restoreProductTypeAPI } from "../../api/apiProductTypes";
import parseError from "../../utils/parseError";

const useRestoreProductType = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreProductType, isPending: isRestore } = useMutation({
        mutationFn: restoreProductTypeAPI,
        onSuccess: (res) => {
            const message = res?.message || "Product type restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["productTypes"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore product type");
        },
    });

    return { restoreProductType, isRestore };
};

export default useRestoreProductType;